
<div class="tab-component">
  <div class="tab-component-wrapper">
    <div class="tab-title">
      <h3>OTA History</h3>
    </div>

    <div class="tab-content">
        <div class="tab-content-wrapper content-wrapper-aggrid">
          <div class="component-ag-grid-wrapper" (contextmenu)="preventDefaultContextMenu($event)" mcAgGridCopyCellTooltip style="position: relative;">
            <ag-grid-angular
            class="ag-theme-alpine"
              style="min-height: 300px;"
              class="ag-theme-alpine"
              [rowModelType]="'infinite'"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              (gridReady)="onGridReady($event)"
              [pagination]="true"
               [rowHeight]="rowHeight"
              [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
              [cacheBlockSize]="paginationPageSize"
              (paginationChanged)="onPaginationChanged($event)"
              [gridOptions]="gridOptions"
              (cellContextMenu)="onCellContextMenu($event)">
            </ag-grid-angular>
            <div class="custom-context-menu" *ngIf="contextMenu.visible" [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x}">
              <ul>
              <li (click)="copyToClipboard(contextMenu.value)">Copy Value</li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>


